// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';
import type { ModerationAlertConfig } from './types';

export const getModerationAlertConfig = wrapWithNetworkError(
  (token: string, clientId: Id) => {
    const fetchUrl = getEndpointUrl(`/mod_alert/client/${clientId}`);
    const fetchOptions = {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json());
  }
);

const setChannelAlertConfig = (method: 'POST' | 'PUT') =>
  wrapWithNetworkError((token: string, config: ModerationAlertConfig) => {
    const fetchUrl = getEndpointUrl(
      `/mod_alert/client/${String(config.client_id)}/channel/${config.channel}`
    );
    const fetchOptions = {
      method,
      headers: {
        'Content-type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(config),
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json());
  });

export const createChannelAlertConfig = setChannelAlertConfig('POST');
export const updateChannelAlertConfig = setChannelAlertConfig('PUT');



// WEBPACK FOOTER //
// ./src/containers/client/alertConfigApi.js